<style lang="stylus">
.register-mytooltip .register-mytext {
  font-size: 14px;
  font-weight: bold;
  visibility: hidden;
  background-color: black;
  color: #fff;
  z-index: 1;
  top: 160%;
  left: -16%;
  margin-left: -90px;
  text-align: center;
  border-radius: 6px;
  padding: 12px 6px;
  position: absolute;
}

.register-mytooltip {
  font-weight: bold;
  position: relative;
  display: inline-block;
}

.register-mytooltip .register-mytext:after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -10px;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.register-mytooltip:hover .register-mytext {
  visibility: visible;
}

@media (min-width: 300px) and (max-width: 320px) {
  .register-mytooltip .register-mytext {
    width: 288px;
    left: -133%;
    padding: 17px 10px;
  }

  .register-mytooltip .register-mytext:after {
    left: 75%;
  }
}

@media (min-width: 321px) and (max-width: 385px) {
  .register-mytooltip .register-mytext {
    width: 331px;
    left: -183%;
    padding: 17px 10px;
  }

  .register-mytooltip .register-mytext:after {
    left: 75%;
  }
}

@media (min-width: 386px) and (max-width: 480px) {
  .register-mytooltip .register-mytext {
    width: 338px;
    left: -198%;
    padding: 17px 10px;
  }

  .register-mytooltip .register-mytext:after {
    left: 78%;
  }
}

@media (min-width: 481px) and (max-width: 620px) {
  .register-mytooltip .register-mytext {
    width: 288px;
    left: 35%;
    padding: 17px 10px;
  }

  .register-mytooltip .register-mytext:after {
    left: 38%;
  }
}

@media (min-width: 620px) {
  .register-mytooltip .register-mytext {
    width: 375px;
  }
}

.extra-height {
  margin-top: 22%;
}
</style>
<template>
  <div style="position: relative">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
      <v-progress-circular color="primary" indeterminate size="48" width="3" />
    </v-overlay>
    <InfoBanner :show="showBanner" @close="showBanner = false" />
    <v-container class="containerFixedHeight">
      <v-row align-center justify="center" wrap style="margin: 3rem auto 5rem auto; max-width: 1590px">
        <v-col cols="12" md="12" v-if="welcomePageTitle">
          <div class="welcome-header-mobile d-flex d-sm-none">
            <span style="background-color: #ffc627; padding: 0 5px">{{ welcomePageTitle }}</span>
          </div>
          <div class="welcome-header d-none d-sm-flex" id="welcomeTitle">
            <span style="background-color: #ffc627; padding: 0 5px">{{ welcomePageTitle }}</span>
          </div>
        </v-col>
        <v-col cols="9" md="6" style="max-width: 700px">
          <div id="welcomeContent" class="welcome-page-message" v-html="intro" />
        </v-col>
        <v-col cols="8" md="8" style="margin-top: 48px">
          <v-row wrap align-end justify="center">
            <v-col cols="6" md="6" class="new-user-register">
              <div class="new-user-text">
                New
                <div>user?</div>
              </div>
              <div
                class="register-button"
                @click="
                  asuoDataLayerClick('createLearner', '0', {
                    section: 'new user'
                  })
                "
              >
                <v-btn @click="handleRegisterClick" :ripple="false" variant="flat" rounded color="#FEFEFE">
                  Register now
                </v-btn>
              </div>
            </v-col>
            <!-- :class="align-center justify-center>= 100 ? 'extra-height' : ''" -->
            <img
              absolute
              class="background-graduate-img"
              src="../assets/images/130509-Undergrad-Graduation-2231 copy.png"
            />
            <v-col cols="6" md="6" class="exisiting-user-login">
              <div class="exisiting-user-text">
                Already have an
                <div><span class="asurite-id-mobile">ASURITE ID?</span></div>
              </div>
              <div class="login-button">
                <v-btn
                  @click="
                    asuoDataLayerClick('createLearner', '1', {
                      section: 'main navbar',
                      region: 'navbar',
                      text: 'login'
                    });
                    login();
                  "
                  :ripple="false"
                  variant="flat"
                  rounded
                  color="#fec627"
                >
                  Log In
                </v-btn>
              </div>
              <div style="text-align: center; margin-top: 8px; margin-bottom: 8px">
                <div
                  class="what-asurite-link register-mytooltip"
                  @click="asuoDataLayerClick('createLearner', '2', { region: 'navbar', section: 'main navbar' })"
                >
                  <a class="d-none d-sm-flex">What is an ASURITE ID?</a>
                  <a class="d-flex d-sm-none"
                    >What is an<br />
                    ASURITE ID?</a
                  >
                  <span class="register-mytext"
                    >When you join ASU as a student, faculty or staff, you receive an ASURITE ID. This is your unique
                    ASU login credential.</span
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { FetchPartnerData } from '../mixins/fetchPartnerDataMixin';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers.js';
import InfoBanner from './InfoBannerComponent.vue';

export default defineComponent({
  emits: ['setInitialForm'],
  components: { InfoBanner },

  data() {
    return {
      background: 'url(imageLocation) right / cover no-repeat',
      intro: '',
      welcomeTitleHeight: '',
      showBanner: false // ULC-3105: ASU email account message disabled
    };
  },

  mixins: [Helper, DataLayerMixin, FetchPartnerData, AjaxLoader],

  methods: {
    setInitialForm() {
      this.asuoDataLayerClick('createLearner', '0', {
        section: 'new user'
      });
      this.$emit('setInitialForm');
    },
    login() {
      this.logInfo('calling asurite login');

      this.$auth.login('asurite');
    },
    loginWithEmail() {
      this.logInfo('calling custom oauth email login');

      this.$auth.login('custom_oauth');
    },
    handleRegisterClick() {
      this.setInitialForm();
      this.$router.push({ name: 'Registerv2' });
    },
    introText() {
      const customIntroTextUlc =
        'Jumpstart your path to higher education with Universal Learner Courses from Arizona State University.';
      const customIntroTextEa =
        'Jumpstart your path to higher education with Earned Admission courses from Arizona State University.';

      const isULCDomain = Helper.methods.isUlcPartner();
      const partnerName = this.$conn.getPartnerName();

      if (!isULCDomain) {
        if (partnerName === 'accelerate' || partnerName === 'hs4cc') {
          return customIntroTextUlc;
        } else if (partnerName === 'starbucks' || partnerName === 'uber' || partnerName === 'google') {
          return customIntroTextEa;
        }
      }

      if (partnerName === 'welcome') {
        return !isULCDomain ? customIntroTextEa : customIntroTextUlc;
      }
      return ((this.$conn.partnerData || {}).welcomePageData || {}).introduction;
    }
  },

  computed: {
    welcomePageTitle() {
      const userStore = useUserStore();
      return userStore.welcomePageData.welcomePageTitle;
    },
    screenWidth() {
      return window.innerWidth > 1263 ? true : false;
    }
  },

  mounted() {
    this.welcomeTitleHeight = document.getElementById('welcomeTitle').offsetHeight;
  },

  created() {
    const userStore = useUserStore();
    if (userStore.welcomePageData.welcomePageTitle == undefined) this.fetchPartnerData();

    this.intro = this.introText();
  }
});
</script>
<style scoped></style>
